import { useState } from "react"
import Loader from "../../UI/Loader/Loader"
import { useContentfulContext } from "../../../contexts/ContentfulContext"
import { useUserContext } from "../../../contexts/UserContext"
import PrimaryModal from "../../UI/Modal/PrimaryModal"
import { SecondaryButton } from "../../UI";
import { deleteRecommendationByIds } from "../../../utils/APIs"
import { toast } from "react-toastify"

const BulkDeleteRecommendationModal = ({ handleClose, refetchData, selectedEnvironment }) => {
    const { content } = useContentfulContext()
    const { userData } = useUserContext()
    const [loading, setLoading] = useState(false);
    const [inputFieldValue, setInputFieldValue] = useState("");
    const [error, setError] = useState("");
    const [deleteFromAllEnvironments, setDeleteFromAllEnvironments] = useState(false);

    const handleSubmit = async () => {
        try {
            if (!inputFieldValue.trim()) {
                setError(content?.RECOMMENDATION_BULK_DELETE_MODAL?.error_message);
                return;
            }
            setLoading(true);
            const ids = inputFieldValue.split(",").map(id => id.trim()).filter(id => id);
            if (ids.length === 0) {
                setError(content?.RECOMMENDATION_BULK_DELETE_MODAL?.error_message);
                return;
            }
            if (ids.length > 50) {
                setError(content?.RECOMMENDATION_BULK_DELETE_MODAL?.max_ids);
                return;
            }
            const payloadData = {
                token: userData?.token,
                organizationId: userData?.selectedOrganization?.org_token,
                tenant: userData?.defaultAdobeIO?.tenant_name,
                ids: ids?.join(","),
            }
            if (!deleteFromAllEnvironments) {
                payloadData.environmentId = selectedEnvironment?.id;
            }
            const result = await deleteRecommendationByIds(payloadData);
            if (result.status) {
                toast.success(content?.RECOMMENDATION_BULK_DELETE_MODAL?.success_message);
                refetchData && refetchData(false, true)
                handleClose();
            } else {
                toast.error(result.message || content?.RECOMMENDATION_BULK_DELETE_MODAL?.failure_message);
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message || error?.message || "Something went wrong"
            toast.error(errMsg || content?.COMMON_MESSAGE.something_wrong_msg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <PrimaryModal title={content?.RECOMMENDATION_BULK_DELETE_MODAL?.title} hideModal={handleClose} widthClass="max-w-2xl">
                {loading && <Loader />}
                <div className="w-full p-6 space-y-4">

                    <div className="space-y-4">

                        <div className="max-w-7xl mx-auto">
                            <div>
                                <div className="relative">
                                    <textarea
                                        type="textarea"
                                        id="ids"
                                        name="ids"
                                        value={inputFieldValue}
                                        className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                        placeholder=" "
                                        onChange={(e) => setInputFieldValue(e.target.value)}
                                        rows={4}
                                    />
                                    <label
                                        htmlFor="ids"
                                        className="absolute text-sm text-black duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        {content?.RECOMMENDATION_BULK_DELETE_MODAL?.input_placeholder}
                                    </label>
                                </div>
                                <p className="mt-2 text-sm text-gray-500">
                                    {content?.RECOMMENDATION_BULK_DELETE_MODAL?.description}
                                </p>
                                <p className="mt-2 text-sm text-red-500">{error}</p>
                            </div>

                            <div className="flex items-center gap-1 mt-2">
                                <input
                                    type="checkbox"
                                    checked={deleteFromAllEnvironments}
                                    onChange={(e) => setDeleteFromAllEnvironments(e.target.checked)}
                                    className="mr-2"
                                />
                                <p className="text-sm font-bold">
                                   {content?.RECOMMENDATION_BULK_DELETE_MODAL?.delete_from_all_environments}
                                </p>
                            </div>

                            <div className="flex justify-end flex-end">
                                <SecondaryButton handleClick={handleSubmit}>
                                    {content?.RECOMMENDATION_BULK_DELETE_MODAL?.submit_button}
                                </SecondaryButton>
                            </div>

                        </div>

                    </div>
                </div>
            </PrimaryModal>
        </>
    )
}

export default BulkDeleteRecommendationModal
